import { useQuery } from "@tanstack/react-query";
import { asyncGetList } from "@/setup/flexbiz-api-provider/coreFunction";
import { staleTime } from "@/types/projectConsts";
import categoryKeys from "../queryKeys/categoryKeys";

/* ─── fetch categories ─── */
export const fetchCategories = async (options: any = {}) =>
  asyncGetList<any[]>({
    collection_name: "ecomcategories_cty",
    options: {
      ...options,
      condition: {
        ...(options?.condition || {}),
      },
      limit: 100,
    },
  });

export const useFetchCategories = (options: any = {}) =>
  useQuery({
    queryKey: categoryKeys.list(options),
    queryFn: () => fetchCategories(options),
    enabled: Boolean(options),
    staleTime: staleTime.LONG,
  });

/* ─── fetch dmnvts (product groups) ─── */
export const fetchDmnvts = async (options: any = {}) =>
  asyncGetList<any[]>({
    collection_name: "dmnvt",
    options: {
      limit: 200,
      ...options,
    },
  });

export const useFetchDmnvts = (options: any = {}) =>
  useQuery({
    queryKey: [{ scope: "dmnvt", type: "list", ...options }],
    queryFn: () => fetchDmnvts(options),
    staleTime: staleTime.LONG,
    enabled: Boolean(options),
  });
